import { Facility, FacilityReservationParty } from '@models/realEstate.types';
import { isFeature } from '@utils/apartmentUtils';

export const getInfoTextTranslationKey = (party: FacilityReservationParty) => {
  const translationPrefix = 'clubHouseReservation.infoText';

  switch (party) {
    case 'SATO_ASPA':
    case 'SATO_HOUSE_EXPERT':
      return `${translationPrefix}.sato`;
    case 'RESIDENTS':
      return `${translationPrefix}.tenantCommitee`;
    case 'HOSTING_COMPANY':
      return `${translationPrefix}.hostingCompany`;
    case 'MAINTENANCE_COMPANY':
      return `${translationPrefix}.maintenanceCompany`;
  }
};

export const getInputFieldInfoTranslationKey = (
  party: FacilityReservationParty | null | undefined
) => {
  const translationPrefix = 'clubHouseReservation.inputFieldInfo';

  switch (party) {
    case 'SATO_ASPA':
    case 'SATO_HOUSE_EXPERT':
      return `${translationPrefix}.sato`;
    default:
      return `${translationPrefix}.other`;
  }
};

export const isClubHouseReservable = (clubHouse: Facility) => {
  if (!isFeature('CLUBHOUSE')(clubHouse)) return false;

  return (
    clubHouse.reservation &&
    clubHouse.reservation?.reservationMethod !== 'NOT_BOOKABLE'
  );
};
